import { array, partial, string } from 'io-ts/Decoder';

import { Area } from '../../../../ui/geometry/Area';

export const Request = partial({
	text: string,
	areas: array(Area),
});
